// extracted by mini-css-extract-plugin
export default {"nutrition":"NutritionItem_nutrition__e+xs+","title":"NutritionItem_title__8LZQS","item":"NutritionItem_item__TVC+S"};